import { Controller } from "@hotwired/stimulus"
import { track } from "../analytics"

export default class RecommendationTrackingController extends Controller {
  trackAuthorClick(event) {
    const link = event.currentTarget
    track("recommendation_author_url_clicked", {
      author_name: link.dataset.authorName,
      author_url: link.href,
      location: link.dataset.location
    })
  }
}
